import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import ScrollToTop from './component/ScrollToTop';
import PageLoader from './component/PageLoader';
import SignatureExperience from './Pages/SignatureExperience';
import Accommodation from './Pages/Accomodation';

// Lazy-load all pages
const HeroSection = lazy(() => import('./Pages/HeroSection/HeroSection'));
const Contact = lazy(() => import('./Pages/Contact'));
const About = lazy(() => import('./Pages/About/About'));
const CafeDConfluence = lazy(() => import('./Pages/CafeDConfluence'));
const Gallery = lazy(() => import('./Pages/Gallery'));
const Gatherings = lazy(() => import('./Pages/Gatherings'));
const Activities = lazy(() => import('./Pages/activities'));
const Blog = lazy(() => import('./Pages/Blog'));
const MunroeArch = lazy(() => import('./Pages/MunroeArch'));
const MunroeIsland = lazy(() => import('./Pages/MunroeIsland'));
const MunroeMain = lazy(() => import('./Pages/MunroeMain'));
const MonsoonMagic = lazy(() => import('./Pages/MonsoonMagic'));
const BackwaterCanoeing = lazy(() => import('./Pages/BackwaterCanoeing'));
const Shikkaraboating = lazy(() => import('./Pages/Shikkaraboating '));
const KayakingPage = lazy(() => import('./Pages/KayakingPage'));
const ScenicOasis = lazy(() => import('./Pages/ScenicOasis'));
const EscapePage = lazy(() => import('./Pages/EscapePlan/EscapePage'));
const IndoorActivities = lazy(() => import('./Pages/IndoorActivities'));
const OutdoorActivities = lazy(() => import('./Pages/OutdoorActivities'));
const KidaPlayArea = lazy(() => import('./Pages/KidaPlayArea'));
const NightBBQSpace = lazy(() => import('./Pages/NightBBQSpace'));
const Faq = lazy(() => import('./Pages/Faq'));


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={PageLoader}>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HeroSection />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/cafe-d-confluence" element={<CafeDConfluence />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/escape-plan" element={<EscapePage />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/the-signature-experience" element={<SignatureExperience />} />
            <Route path="/gatherings" element={<Gatherings />} />
            <Route path="/highlights" element={<Activities />} />
            <Route path="/munroe-arch" element={<MunroeArch />} />
            <Route path="/munroe-island" element={<MunroeIsland />} />
            <Route path="/MunroeIsland" element={<MunroeMain />} />
            <Route path="/monsoon-magic" element={<MonsoonMagic />} />
            <Route path="/backwater-canoeing" element={<BackwaterCanoeing />} />
            <Route path="/shikkara-boating" element={<Shikkaraboating />} />
            <Route path="/kayaking" element={<KayakingPage />} />
            <Route path="/scenic-oasis" element={<ScenicOasis />} />
            <Route path="/indoor-leisure-activities" element={<IndoorActivities />} />
            <Route path="/outdoor-recreational-activities" element={<OutdoorActivities />} />
            <Route path="/kids-play-area" element={<KidaPlayArea />} />
            <Route path="/night-bbq-space" element={<NightBBQSpace />} />
            <Route path="/faqs" element={<Faq />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}


export default App;



